import React, { useContext } from 'react';

export const Code = props => {
    const { color } = props;

    return (
        <svg viewBox='0 0 18 18'>
            <polyline
                stroke={color ? color : '#000000'}
                fill={color ? color : '#000000'}
                points='5 7 3 9 5 11'
            ></polyline>
            <polyline
                stroke={color ? color : '#000000'}
                fill={color ? color : '#000000'}
                points='13 7 15 9 13 11'
            ></polyline>
            <line
                stroke={color ? color : '#000000'}
                fill={color ? color : '#000000'}
                x1='10'
                x2='8'
                y1='5'
                y2='13'
            ></line>
        </svg>
    );
};
